import React from "react";
import wmsLogo from "../images/WMS-logo-2025-1.jpg";

const Intro = () => {
  return (
    <>
      <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id="about">
        <div
          className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
          data-aos="fade-up"
        >
          <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
            <img
              alt="card img"
              className="rounded-t float-right"
              src={wmsLogo}
            />
          </div>
          <div
            className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            <h3 className="text-3xl  text-blue-900 font-bold">
              Welcome to White Mountain Strategies, your Trusted Partner in
              navigating the ever-evolving Blockchain Ecosystem.{" "}
            </h3>
            <div>
              <p className="my-3 text-xl text-gray-600 font-semibold">
                We specialize in delivering actionable insights, cutting-edge
                trading strategies, and exclusive investment opportunities to
                help you thrive in the crypto economy. Whether you're a seasoned
                investor or exploring blockchain for the first time, our team
                combines deep technical expertise with a forward-thinking
                approach to unlock your potential in this transformative
                industry.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
